export const NOTIFICATIONS_READ_KEY = 'gyym:NotificationsRead' as const
